module.exports = __webpack_public_path__ + "img/gzhj_09.c8aafeee.jpg";